import { IBase } from '../../models'
import {
  IFetchUnsubscribeReasonsAction,
  ISetIsLoadingUnsubscribeAction,
  ISetUnsubscribeReasonsAction,
  IUnsubscribeAction,
  UnsubscribeTypeKeys
} from '../types'

export function unsubscribeAction(reasonId: number): IUnsubscribeAction {
  return { type: UnsubscribeTypeKeys.UNSUBSCRIBE, payload: reasonId.toString() }
}

export function fetchUnsubscribeReasonsAction(): IFetchUnsubscribeReasonsAction {
  return { type: UnsubscribeTypeKeys.FETCH_UNSUBSCRIBE_REASONS }
}

export function setUnsubscribeReasonsAction(reasons: IBase[]): ISetUnsubscribeReasonsAction {
  return { type: UnsubscribeTypeKeys.SET_UNSUBSCRIBE_REASONS, payload: reasons }
}

export function setIsLoadingUnsubscribeAction(loading: boolean): ISetIsLoadingUnsubscribeAction {
  return { type: UnsubscribeTypeKeys.IS_LOADING_UNSUBSCRIBE, payload: loading }
}
